import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Reports/hooks/useReport.ts
function useReport(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Reports.GetReport.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useReport };

//# sourceMappingURL=useReport.js.map